<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter"><a id="illustration-ct1"></a>ILLUSTRATIONS </h2>
<p class="noindent"><a class="nounder" href="#/xhtml/fm1">Life Springs Anew</a></p>
<p class="paraspaceabove"><a class="nounder" href="#/xhtml/preface_a">The Empty Bag</a></p>
<p class="paraspaceabove"><a class="nounder" href="#/xhtml/introduction#img1">The Color of Violet</a></p>
<p class="paraspaceabove"><a class="nounder" href="#/xhtml/part1a">Spirit Search</a></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/part2a" title="Link target outside of Sample">Tree Sees Forest</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/part3a" title="Link target outside of Sample">The Promise of Riches</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/part4a" title="Link target outside of Sample">Beast within the Beauty</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch14#img3" title="Link target outside of Sample">Grandma Was Right</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/part5a" title="Link target outside of Sample">The Light of Grace</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch19#img4" title="Link target outside of Sample">Life Is What You Make It</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch23#img5" title="Link target outside of Sample">The Gift of Every Breath</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch24#img6" title="Link target outside of Sample">Wopstegwan you Kiyew</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch24#img7" title="Link target outside of Sample">Strong Mind</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch25#img8" title="Link target outside of Sample">The Master</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/part6a" title="Link target outside of Sample">The Little Girl</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch31#img9" title="Link target outside of Sample">A Good Boy</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/ch32b" title="Link target outside of Sample">Where Wisdom Goes to Die</span></p>
<p class="paraspaceabove"><span class="nounder" href="#/xhtml/conclusion#img10" title="Link target outside of Sample">The Philosopher Smokes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustration.vue?2926b912